/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
`;

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1800px;
  width: 100%;
`;
